import {
  FunctionComponent,
} from 'react';
import { Route } from 'react-router-dom';

import { AdminRouteName } from '../CONSTANTS';
import DashboardWrap from '../../components/DashboardWrap';
import {
  SettledRentCollection,
  AwaitingRentCollection,
  RefundedRentCollection,
  AllRentCollection,
  PendingPaymentRentCollection,
} from './_partials';

import './AdminRentCollection.scss';

const AdminRentCollection: FunctionComponent = () => (
  <DashboardWrap>
    <div className="rent-payment-root-cover">
      <Route
        component={AllRentCollection}
        path={AdminRouteName.rentCollectionRoute}
        exact
      />
      <Route
        component={SettledRentCollection}
        path={AdminRouteName.rentCollectionSettledRoute}
        exact
      />
      <Route
        component={AwaitingRentCollection}
        path={AdminRouteName.rentCollectionAwaitingSettlement}
      />
      <Route component={RefundedRentCollection} path={AdminRouteName.rentCollectionRefunded} />
      <Route
        component={PendingPaymentRentCollection}
        path={AdminRouteName.rentCollectionPendingPayment}
      />
    </div>
  </DashboardWrap>
);

export default AdminRentCollection;
